module.exports = __webpack_public_path__ + "img/live_background.dd614e7d.jpg";